import { useState } from 'react';

export type UseRefreshType = () => [number, () => void];

const useRefresh = () => {

  const [mustRefresh, doRefresh] = useState(0);

  const refresh = () => {
    doRefresh(mustRefresh + 1);
  };

  return [mustRefresh as number, refresh as React.Dispatch<any>];
};

export default useRefresh as UseRefreshType;
